import { AuthorityPage } from './AuthorityPage';
export default AuthorityPage;
